<mat-card class="d-flex flex-column p-0 mat-elevation-z0 h-100">
  <div class="m-3 flex-grow-1">
    <!-- [matTooltip]="(vehicleValuation.title.length > 30)? vehicleValuation.title : ''" -->
    <h2 class="mb-0 vehicle-title">
      {{vehicleValuation.garage.title}}
      <span class="vehicle-subtitle">{{vehicleValuation.garage.subTitle}}</span>
    </h2>
    <!-- <h3 class="caption mb-0 garage-subtitle">{{vehicleValuation.subTitle}}</h3> -->
  </div>

  <div class="position-relative">
    <div class="asi-badge shadow-sm"
      *ngIf="vehicleValuation?.garage?.isAsi"
      [matTooltip]="'COMMON.LABEL.ASI_SUBSCRIPTION' | translate">
      <img
        src="https://res.cloudinary.com/classic-car-investor/image/upload/f_auto/q_auto/dpr_2/h_40/v1665604103/logo-asi_t9quwi.png">
    </div>
    <div class="garage-pills d-flex align-items-start">
      <span class="flex-grow-1"></span>
      <span class="pill rounded-pill mr-1 shadow-sm">
        +{{vehicleValuation.netGainInPercentage}}%
        in
        {{'COMMON.LABEL.' + vehicleValuation.investmentDuration.length |
        translate}}
      </span>
    </div>

    <cci-vehicle-gallery size="small"
      [galleryTitle]="vehicleValuation?.garage.fullTitle"
      [showGallery]="showGallery"
      [gallery]="vehicleValuation?.garage.vehicleGallery"
      [youtubeEmbedUrl]="vehicleValuation?.garage.youtubeEmbedUrl"
      class="px-1"></cci-vehicle-gallery>
  </div>

  <div class="px-3 pt-2"
    *ngIf="showSuggestedVehicleValuation">
    <div class="row">
      <div class="col key">{{'COMMON.LABEL.BUY_AT' | translate}}</div>
      <div class="col val">{{vehicleValuation.buyPrice | number}}&euro;</div>
      <div class="col-24 my-1">
        <mat-divider>
        </mat-divider>
      </div>
    </div>
    <div class="row">
      <div class="col key">{{'COMMON.LABEL.SELL_AT' | translate}} </div>
      <div class="col val">{{vehicleValuation.sellPrice | number}}&euro;</div>
      <div class="col-24 my-1">
        <mat-divider>
        </mat-divider>
      </div>
    </div>
    <div class="row">
      <div class="col key">{{'COMMON.LABEL.EARN' | translate}} </div>
      <div class="col val">{{vehicleValuation.netGainInCash | number}}&euro;</div>
    </div>
  </div>

  <!-- {{vehicleValuation.sellPrice | number}}&euro; -->
  <!-- {{'COMMON.LABEL.AND_EARN' | translate}}  -->


  <div *ngIf="showVehicleValuations">
    <div class="row"
      *ngIf="vehicleValuation.garage.getValuationForInvestmentDuration(eInvestmentLength.MONTHS_6)">
      <div class="col key">{{'COMMON.LABEL.MONTHS_6' | translate }}</div>
      <div class="col val">
        {{vehicleValuation.garage.getValuationForInvestmentDuration(eInvestmentLength.MONTHS_6).sellPrice |
        number}}&euro;
      </div>
    </div>
    <div class="row"
      *ngIf="vehicleValuation.garage.getValuationForInvestmentDuration(eInvestmentLength.YEARS_1)">
      <div class="col">{{'COMMON.LABEL.YEARS_1' | translate }}</div>
      <div class="col">
        {{vehicleValuation.garage.getValuationForInvestmentDuration(eInvestmentLength.YEARS_1).sellPrice |
        number}}&euro;</div>
    </div>
    <div class="row"
      *ngIf="vehicleValuation.garage.getValuationForInvestmentDuration(eInvestmentLength.YEARS_2)">
      <div class="col">{{'COMMON.LABEL.YEARS_2' | translate }}</div>
      <div class="col">
        {{vehicleValuation.garage.getValuationForInvestmentDuration(eInvestmentLength.YEARS_2).sellPrice |
        number}}&euro;</div>
    </div>
    <div class="row"
      *ngIf="vehicleValuation.garage.getValuationForInvestmentDuration(eInvestmentLength.YEARS_3)">
      <div class="col">{{'COMMON.LABEL.YEARS_3' | translate }}</div>
      <div class="col">
        {{vehicleValuation.garage.getValuationForInvestmentDuration(eInvestmentLength.YEARS_3).sellPrice |
        number}}&euro;</div>
    </div>
  </div>

  <div *ngIf="editInvestmentDuration">
    <mat-button-toggle-group [(ngModel)]="vehicleValuation.investmentDuration.length"
      aria-label="Durata investimento">
      <mat-button-toggle value="MONTHS_6"
        *ngIf="vehicleValuation.garage.getValuationForInvestmentDuration(eInvestmentLength.YEARS_3)">
        {{'COMMON.LABEL.6_MONTHS_SHORT' | translate }}
      </mat-button-toggle>
      <mat-button-toggle value="YEARS_1"
        *ngIf="vehicleValuation.garage.getValuationForInvestmentDuration(eInvestmentLength.YEARS_1)">
        {{'COMMON.LABEL.1_YEAR_SHORT' | translate }}
      </mat-button-toggle>
      <mat-button-toggle value="YEARS_2"
        *ngIf="vehicleValuation.garage.getValuationForInvestmentDuration(eInvestmentLength.YEARS_2)">
        {{'COMMON.LABEL.2_YEAR_SHORT' | translate }}
      </mat-button-toggle>
      <mat-button-toggle value="YEARS_3"
        *ngIf="vehicleValuation.garage.getValuationForInvestmentDuration(eInvestmentLength.YEARS_3)">
        {{'COMMON.LABEL.3_YEAR_SHORT' | translate }}
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <a mat-raised-button
    *ngIf="showVehicleDetailsButton"
    class="w-100 mt-2"
    color="accent"
    [routerLink]="['']">
    {{'COMMON.BUTTON.DETAILS' | translate}}
  </a>
</mat-card>